import { useState } from "react";
import Button from "../extra/Button";
import Input from "../extra/Input";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../store/admin/admin.action";
import { connect } from "react-redux";
import EraShop from "../../assets/images/EraShopImage.png"
import loginlogo2 from "../../assets/images/loginlogo2.png"
import { apiClient } from "../../api/client";
import { setToast } from "../../util/toast";

const Login = (props) => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);

  const [error, setError] = useState({
    email: "",
    otp: "",
  });

  const handleSendOtp = async () => {
    if (!email) {
      setError((prev) => ({ ...prev, email: "Email Is Required !" }));
      return;
    }

    const checkRes = await apiClient.post("/v1/auth/check-user", { email });
    if (!checkRes.ok || !checkRes.data?.ok) {
      setToast("error", checkRes.data?.error?.message || checkRes.message);
      return;
    }

    if (!checkRes.data?.data?.exists) {
      setToast("error", checkRes.data?.error?.message || "User not found");
      return;
    }

    const loginRes = await apiClient.post("/v1/auth/login", { email });
    if (!loginRes.ok || !loginRes.data?.ok) {
      setToast("error", loginRes.data?.error?.message || loginRes.message);
      return;
    }

    setOtpSent(true);
    setToast("success", loginRes.data?.data?.message || "OTP sent");
  };

  const handleVerifyOtp = async () => {
    if (!otp) {
      setError((prev) => ({ ...prev, otp: "OTP is required !" }));
      return;
    }

    const verifyRes = await apiClient.post("/v1/auth/verify-otp", {
      email,
      otp,
    });
    if (!verifyRes.ok || !verifyRes.data?.ok) {
      setToast("error", verifyRes.data?.error?.message || verifyRes.message);
      return;
    }

    const token = verifyRes.data?.data?.token;
    if (token) {
      props.loginAdmin(token);
      setToast("success", "Login Successfully!");
      setTimeout(() => {
        navigate("/admin");
      }, 1500);
    } else {
      setToast("error", "Token missing from response");
    }
  };

  return (
    <>
      <div className="mainLoginPage">
        <div className="loginDiv">
          <div className="row">
            <div
              className="col-xl-6 d-xxl-block d-xl-block d-none boxCenter p-5"
            style={{ background: "#B93160" }}
            >
                <img
                  className="img-fluid"
                  src={EraShop}
                  alt="text logo"
                  srcset=""
                />
                <img className="img-fluid"
                src={loginlogo2}
                alt="login logo" />
            </div>
            <div className="col-xl-6 col-md-12 boxCenter"
              style={{
                background: "#FEFEFE"
              }}
            >
              <div className="loginDiv2">
                <div className="loginPage pt-3">
                  <div className="my-4">
                    <div className="loginLogo me-3 pt-1 pe-1">
                      <img
                        src={require("../../assets/images/Eralogo22.png")}
                        alt=""
                        width={"80px"}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      color: "#000",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "22px",
                      letterSpacing: "0.48px",
                    }}
                    className=""
                  >
                    <p>Welcome back !!!</p>
                  </div>
                  <div className=" mb-3">
                    <h3
                      className="fw-bold text-dark"
                      style={{ fontSize: "56px", fontWeight: "600" }}
                    >
                      Log In
                    </h3>
                  </div>
                  <div className="loginInput">
                    <Input
                      label={`Email`}
                      id={`loginEmail`}
                      type={`email`}
                      value={email}
                      style={{ background: "rgba(185, 49, 96, 0.11)" }}
                      errorMessage={error.email && error.email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...error,
                            email: `Email Is Required`,
                          });
                        } else {
                          return setError({
                            ...error,
                            email: "",
                          });
                        }
                      }}
                    />

                    {otpSent && (
                      <Input
                        label={`OTP`}
                        id={`loginOtp`}
                        type={`text`}
                        value={otp}
                        errorMessage={error.otp && error.otp}
                        onChange={(e) => {
                          setOtp(e.target.value);
                          if (!e.target.value) {
                            return setError({
                              ...error,
                              otp: `OTP is required`,
                            });
                          } else {
                            return setError({
                              ...error,
                              otp: "",
                            });
                          }
                        }}
                      />
                    )}
                  </div>

                  <span className="d-flex align-items-center justify-content-end fw-semibold pdlogin">
                    <a href="/forgotPassword" style={{ color: "#7E7E7E " }}>
                      Forgot password?
                    </a>
                  </span>

                  <div className="loginButton mt-5">
                  
                    {!otpSent && (
                      <Button
                        newClass={`blackFont ms-3`}
                        btnColor={`btnBlackPrime`}
                        style={{
                          borderRadius: "20px",
                          width: "170px",
                          height: "46px",
                          color:"#fff"
                        }}
                        btnName={`Log In`}
                        onClick={handleSendOtp}
                      />
                    )}
                    {otpSent && (
                      <Button
                        newClass={`blackFont ms-3`}
                        btnColor={`btnBlackPrime`}
                        style={{
                          borderRadius: "20px",
                          width: "170px",
                          height: "46px",
                          color:"#fff"
                        }}
                        btnName={`Verify`}
                        onClick={handleVerifyOtp}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { loginAdmin })(Login);

{
  /*  */
}
